import React from 'react'
import { FormikProps } from 'formik'
import {
  FormValues as CompanyFormValues,
  FieldName as CompanyFieldName,
} from 'utils/form/companyForm'
import { AddressInput } from 'components/AddressInput'
import TextInput from 'components/TextInput'

export interface CreateCompanyProps {
  companyForm: FormikProps<CompanyFormValues>
  isDisabled?: boolean
  resetOnCancel?: boolean
}

const CreateEditCompany = ({ companyForm, isDisabled = false }: CreateCompanyProps) => (
  <>
    <TextInput
      disabled={isDisabled}
      name={CompanyFieldName.NAME}
      label="Company name"
      value={companyForm.values.name}
      isFullWidth
      onChange={companyForm.handleChange}
      onBlur={companyForm.handleBlur}
      errorMessage={
        companyForm.touched.name && companyForm.errors.name ? companyForm.errors.name : undefined
      }
    />
    <AddressInput
      isDisabled={isDisabled}
      onTouched={(touched) => {
        companyForm.setTouched({ ...companyForm.touched, Address: touched })
      }}
      errors={companyForm.errors.Address}
      touched={companyForm.touched.Address}
      value={companyForm.values.Address}
      onChange={(address) => {
        companyForm.setValues({
          ...companyForm.values,
          Address: {
            id: companyForm.values.Address.id,
            ...address,
          },
        })
      }}
    />
  </>
)

export { CreateEditCompany }
